import {ExternalLink} from 'lucide-react'
import {useLanguage} from '@/contexts/LanguageContext'

const gameAssets = [
  {
    key: 'calories' as const,
    url: 'https://calories.nygmagames.cc/',
    image: 'https://static.lumi.new/dc/dc99046052cd34d197061151b1dfa465.png',
  },
  {
    key: 'match3' as const,
    url: 'https://match3.nygmagames.cc/',
    image: 'https://static.lumi.new/01/016998550a7e9d18924a71b0b25fa6d0.png',
  },
  {
    key: 'quizMax' as const,
    url: 'https://quiz.nygmagames.cc/',
    image: 'https://static.lumi.new/3e/3e66d8210ccdabb630d83cf20c79623c.png',
  },
]

function MaxGamesSection() {
  const {t} = useLanguage()

  return (
    <section className="relative z-10 px-6 py-20">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">{t.maxGames.title}</h2>
        <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto leading-relaxed">{t.maxGames.subtitle}</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {gameAssets.map(game => (
            <a
              key={game.key}
              href={game.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group block rounded-xl border border-white/10 bg-slate-900/60 overflow-hidden transition-all duration-300 hover:border-indigo-400/50 hover:shadow-lg hover:shadow-indigo-500/20 hover:-translate-y-1"
            >
              <div className="aspect-[9/16] w-full overflow-hidden bg-slate-800">
                <img src={game.image} alt={t.maxGames.games[game.key]} className="w-full h-full object-cover" />
              </div>
              <div className="p-4 flex items-center justify-between">
                <span className="text-base font-semibold text-white">{t.maxGames.games[game.key]}</span>
                <ExternalLink className="w-4 h-4 text-gray-500 group-hover:text-indigo-400 transition-colors" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MaxGamesSection
